import { type ReactNode, useState } from 'react';
import Input from '@/components/Input/Input';
import { VStack } from '@/components/Layout';
import { ControlledSelect } from '@/components/Select/ControlledSelect';
import { CFormItemBase, type CFormItemProps, buildCFormItem } from '../CFormItem';
type Option = {
  value: string;
  label: string;
};
type Props = CFormItemProps & {
  value?: string;
  onChange: (value: string) => void;
  inputClassName?: string;
  fetchOptions?: (text?: string) => Promise<Option[]>;
  /** 初期表示の値 */
  displayValue?: string;
  readComponent?: ReactNode;
  hideSearch?: boolean;
  inputWidth?: number | string;
  /**
   * 「その他」選択時にテキスト入力を表示するためのオプション値。
   * この値が選択された場合、追加のテキスト入力フィールドが表示される。
   */
  otherOptionValue?: string;
  /** 「その他」テキストの現在値 */
  otherTextValue?: string;
  /** 「その他」テキスト変更時のコールバック */
  onOtherTextChange?: (text: string) => void;
  /** 「その他」テキスト入力のプレースホルダー */
  otherTextPlaceholder?: string;
};

/**
 * Card-based Form / SelectItem
 */
export const CFormSelectItem = buildCFormItem((props: Props) => {
  const [localOtherText, setLocalOtherText] = useState(props.otherTextValue ?? '');
  const [prevOtherTextValue, setPrevOtherTextValue] = useState(props.otherTextValue);
  if (props.otherTextValue !== prevOtherTextValue) {
    setPrevOtherTextValue(props.otherTextValue);
    setLocalOtherText(props.otherTextValue ?? '');
  }
  const isOtherSelected = props.otherOptionValue != null && props.value === props.otherOptionValue;
  const handleOtherTextChange = (text: string) => {
    setLocalOtherText(text);
    props.onOtherTextChange?.(text);
  };
  const readDisplay = isOtherSelected && localOtherText ? `${props.displayValue} (${localOtherText})` : props.displayValue;
  return <CFormItemBase {...props} readComponent={props.readComponent ?? readDisplay} writeComponent={<VStack className="gap-2">
          <ControlledSelect id={props.id} label={props.displayValue} value={props.value} onChange={option => props.onChange(option?.value ?? '')} fetchOptions={props.fetchOptions} hideSearch={props.hideSearch} allowEmpty={!props.required} width={props.inputWidth} disabled={props.readonly} />
          {isOtherSelected && <Input value={localOtherText} onChange={e => handleOtherTextChange(e.target.value)} placeholder={props.otherTextPlaceholder} disabled={props.readonly} />}
        </VStack>} />;
});